import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, Output, COMPILER_OPTIONS, CompilerFactory, Compiler, APP_INITIALIZER, NgModule } from '@angular/core';
import { ClipboardModule } from 'ngx-clipboard';
import * as i4$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';
import * as i3$1 from 'ngx-json-viewer';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import * as i4 from '@un-fao/lightforms-lib/lightforms-components';
import { DetailDirective, ListDirective, UserRegisterComponent, LightformsComponentsModule } from '@un-fao/lightforms-lib/lightforms-components';
import * as i1 from '@un-fao/lightforms-lib/lightforms-services';
import { ConfigurationService, LightformsServicesModule } from '@un-fao/lightforms-lib/lightforms-services';
import * as i2 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import * as i3 from 'primeng/api';
import * as i1$1 from 'primeng/dynamicdialog';
import * as i4$2 from 'primeng/button';

function DetailPageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "span", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("common.loading"));
} }
class DetailPageComponent extends DetailDirective {
    constructor(searchService, router, route, utilsService, collectionService, confirmationService, collectionItemService, userselectionService, dialogService, configService, userService, formDataService, workspaceService, loggingService, templateService, propertiesService, listConfigService, dynamicFormControlService, cacheService) {
        super(searchService, router, route, utilsService, collectionService, confirmationService, collectionItemService, userselectionService, dialogService, configService, userService, formDataService, workspaceService, loggingService, templateService, propertiesService, listConfigService, dynamicFormControlService, cacheService);
        this.operation = "view";
        this.visible = true;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }
    ngOnInit() {
        this.init();
    }
    ngOnDestroy() {
        this.loggingService.log = [];
    }
    static { this.ɵfac = function DetailPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DetailPageComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3.ConfirmationService), i0.ɵɵdirectiveInject(i4.FormDataService), i0.ɵɵdirectiveInject(i4.UserselectionService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UsersService), i0.ɵɵdirectiveInject(i4.FormDataService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.LoggingService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.CacheService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DetailPageComponent, selectors: [["detail-page"]], inputs: { space: "space", collection: "collection", alias: "alias", operation: "operation" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [["class", "row spinner", 4, "ngIf"], [1, "row", "detail-page", "collections"], [3, "space", "collection", "alias"], [1, "row", "spinner"], [1, "col-md-12", "mb-3", "align-center"], ["role", "status", 1, "spinner-border"], [1, "sr-only"]], template: function DetailPageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DetailPageComponent_div_0_Template, 5, 1, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵelement(2, "collection-item", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("space", ctx.space)("collection", ctx.collection)("alias", ctx.alias);
        } }, dependencies: [i4$1.NgIf, i4.CollectionItemComponent], styles: [".collection-item-edit[_ngcontent-%COMP%]{margin-left:.5em;margin-top:.2em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DetailPageComponent, [{
        type: Component,
        args: [{ selector: 'detail-page', standalone: false, template: "<div class=\"row spinner\" *ngIf=\"loading\">\r\n  <div class=\"col-md-12 mb-3 align-center\">\r\n    <div class=\"spinner-border\" role=\"status\">\r\n      <span class=\"sr-only\">{{ configService.getTranslation('common.loading')}}</span>\r\n    </div>\r\n  </div>  \r\n</div>\r\n\r\n<div class=\"row detail-page collections\">\r\n  <collection-item [space]=\"space\" [collection]=\"collection\" [alias]=\"alias\"></collection-item>\r\n</div>", styles: [".collection-item-edit{margin-left:.5em;margin-top:.2em}\n"] }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.CollectionService }, { type: i3.ConfirmationService }, { type: i4.FormDataService }, { type: i4.UserselectionService }, { type: i1$1.DialogService }, { type: i1.ConfigurationService }, { type: i1.UsersService }, { type: i4.FormDataService }, { type: i1.WorkspaceService }, { type: i1.LoggingService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: i1.DynamicFormControlService }, { type: i1.CacheService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], alias: [{
            type: Input
        }], operation: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DetailPageComponent, { className: "DetailPageComponent", filePath: "src/reporting/detail-page/detail-page.component.ts", lineNumber: 14 }); })();

class ListPageComponent {
    constructor() {
        this.reporting = false;
    }
    ngOnInit() {
    }
    static { this.ɵfac = function ListPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ListPageComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ListPageComponent, selectors: [["list-page"]], inputs: { space: "space", name: "name", listTemplate: "listTemplate" }, standalone: false, decls: 1, vars: 3, consts: [[3, "space", "name", "listTemplate"]], template: function ListPageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "collection-list", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("space", ctx.space)("name", ctx.name)("listTemplate", ctx.listTemplate);
        } }, dependencies: [i4.CollectionListComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListPageComponent, [{
        type: Component,
        args: [{ selector: 'list-page', standalone: false, template: "<collection-list [space]=\"space\" [name]=\"name\" [listTemplate]=\"listTemplate\"></collection-list>" }]
    }], () => [], { space: [{
            type: Input
        }], name: [{
            type: Input
        }], listTemplate: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListPageComponent, { className: "ListPageComponent", filePath: "src/reporting/list-page/list-page.component.ts", lineNumber: 8 }); })();

class ReportingComponent {
    ngOnInit() { }
    static { this.ɵfac = function ReportingComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportingComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportingComponent, selectors: [["app-reporting"]], standalone: false, decls: 2, vars: 0, consts: [[1, "row"], [1, "col-md-12"]], template: function ReportingComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementEnd();
        } }, styles: [".advanced-search-form[_ngcontent-%COMP%]{padding:1em;border:solid 1px var(--default-border-color);border-radius:5px}.reporting-header[_ngcontent-%COMP%]{display:flex;flex-grow:1}.reporting-header[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{width:100%;margin-right:.5em;padding-top:2px}.buttons[_ngcontent-%COMP%]{display:flex}.buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:2px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportingComponent, [{
        type: Component,
        args: [{ selector: 'app-reporting', standalone: false, template: "<div class=\"row\">\r\n  <div class=\"col-md-12\">\r\n\r\n  </div>\r\n</div>", styles: [".advanced-search-form{padding:1em;border:solid 1px var(--default-border-color);border-radius:5px}.reporting-header{display:flex;flex-grow:1}.reporting-header .form-group{width:100%;margin-right:.5em;padding-top:2px}.buttons{display:flex}.buttons button{margin-left:2px}\n"] }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReportingComponent, { className: "ReportingComponent", filePath: "src/reporting/reporting/reporting.component.ts", lineNumber: 9 }); })();

function TestListPageComponent_html_renderer_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "html-renderer", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.name)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList)("template", ctx_r0.template);
} }
class TestListPageComponent extends ListDirective {
    constructor(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService, formDataService, dialogService, mapService) {
        super(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService);
        this.formDataService = formDataService;
        this.dialogService = dialogService;
        this.mapService = mapService;
    }
    ngOnInit() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.route.params.subscribe(params => {
            this.space = params['space'];
            this.name = params['collection'];
            this.template = '<h1>Test list page</h1>' +
                '<div class="row">' +
                '<div class="col-md-12">' +
                '<fi-filter [space]="space" [collection]="collection" [collectionForm]="collectionForm" [data]="data"></fi-filter>' +
                '</div>' +
                '<div class="col-md-12">' +
                '<fi-search-pills [space]="space" [collection]="collection" [collectionForm]="collectionForm" [data]="data"></fi-search-pills>' +
                '</div>' +
                '<div ngClass="{{ (collectionForm.formConfig.viewConfig?.showFilterTerms && data.aggregations && data.aggregations.length > 0 ? \'col-md-10 results\' : \'col-md-12 results\') }}">' +
                '<fi-list [space]="space" [collection]="collection" [collectionForm]="collectionForm" [data]="data"></fi-list>' +
                '</div>' +
                '<div class="col-md-2">' +
                '<fi-filter-terms [space]="space" [collection]="collection" [collectionForm]="collectionForm" [data]="data"></fi-filter-terms>' +
                '</div>' +
                '</div>';
            this.init();
        });
    }
    static { this.ɵfac = function TestListPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TestListPageComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3.ConfirmationService), i0.ɵɵdirectiveInject(i4.UserselectionService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(i4.FormDataService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TestListPageComponent, selectors: [["app-test-list-page"]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "space", "collection", "collectionForm", "data", "template", 4, "ngIf"], [3, "space", "collection", "collectionForm", "data", "template"]], template: function TestListPageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, TestListPageComponent_html_renderer_0_Template, 1, 5, "html-renderer", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.resultList);
        } }, dependencies: [i4$1.NgIf, i4.HtmlRendererComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TestListPageComponent, [{
        type: Component,
        args: [{ selector: 'app-test-list-page', standalone: false, template: "<html-renderer *ngIf=\"resultList\" [space]=\"space\" [collection]=\"name\" [collectionForm]=\"collectionForm\" [data]=\"resultList\" [template]=\"template\"></html-renderer>" }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i0.ElementRef }, { type: i1.CollectionService }, { type: i3.ConfirmationService }, { type: i4.UserselectionService }, { type: i1.WorkspaceService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: i4.FormDataService }, { type: i1$1.DialogService }, { type: i1.MapService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TestListPageComponent, { className: "TestListPageComponent", filePath: "src/reporting/test-list-page/test-list-page.component.ts", lineNumber: 14 }); })();

class DataEditorComponent {
    constructor(router) {
        this.router = router;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }
    ngOnInit() {
    }
    ngOnDestroy() {
    }
    static { this.ɵfac = function DataEditorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DataEditorComponent)(i0.ɵɵdirectiveInject(i2.Router)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataEditorComponent, selectors: [["data-editor"]], standalone: false, decls: 2, vars: 1, consts: [[1, "row", "data-editor"], [3, "editing"]], template: function DataEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "collection-item", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("editing", true);
        } }, dependencies: [i4.CollectionItemComponent], styles: [".errors-log[_ngcontent-%COMP%]{color:var(--danger-color)}.error-code[_ngcontent-%COMP%]{font-weight:700;margin-right:.5em}.simple-list[_ngcontent-%COMP%]{margin-bottom:0!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataEditorComponent, [{
        type: Component,
        args: [{ selector: 'data-editor', standalone: false, template: "<div class=\"row data-editor\">\r\n  <collection-item [editing]=\"true\"></collection-item>\r\n</div>", styles: [".errors-log{color:var(--danger-color)}.error-code{font-weight:700;margin-right:.5em}.simple-list{margin-bottom:0!important}\n"] }]
    }], () => [{ type: i2.Router }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DataEditorComponent, { className: "DataEditorComponent", filePath: "src/data-editor/data-editor.component.ts", lineNumber: 14 }); })();

function FooterComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.template, i0.ɵɵsanitizeHtml);
} }
class FooterComponent {
    constructor(configService) {
        this.configService = configService;
        this.type = "site";
    }
    async ngOnInit() {
        let template = await this.configService.loadFile('assets/templates/' + this.type + '/footer_' + this.configService.env.currentLang + '.html', 'text');
        template = template.replaceAll("/images/corporatelibraries", "https://www.fao.org/images/corporatelibraries");
        this.template = template;
    }
    static { this.ɵfac = function FooterComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FooterComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["fao-footer"]], inputs: { type: "type" }, standalone: false, decls: 1, vars: 1, consts: [[3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FooterComponent_div_0_Template, 1, 1, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.template);
        } }, dependencies: [i4$1.NgIf], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{ selector: 'fao-footer', standalone: false, template: "<div *ngIf=\"template\" [innerHTML]=\"template\"></div>" }]
    }], () => [{ type: i1.ConfigurationService }], { type: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FooterComponent, { className: "FooterComponent", filePath: "src/fao/footer/footer.component.ts", lineNumber: 9 }); })();

const _c0 = () => ["/"];
const _c1 = a0 => [a0];
const _c2 = (a0, a1) => ({ title: a0, type: a1 });
function HeaderComponent_ng_container_0_ng_container_4_fi_template_renderer_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 31);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("template", ctx_r1.discover);
} }
function HeaderComponent_ng_container_0_ng_container_4_ng_container_16_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 33);
    i0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ng_container_4_ng_container_16_a_1_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r3); const lang_r4 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.changeLanguage(lang_r4.code)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", !ctx_r1.configService.env.enabledLanguages.includes(lang_r4.code) ? "disabled" : "");
    i0.ɵɵattribute("aria-label", lang_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(lang_r4.label);
} }
function HeaderComponent_ng_container_0_ng_container_4_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_4_ng_container_16_a_1_Template, 2, 3, "a", 32);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lang_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", lang_r4.code !== ctx_r1.configService.env.currentLang);
} }
function HeaderComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "header", 5)(2, "div", 6)(3, "div", 7)(4, "div", 8)(5, "div", 9)(6, "a", 10);
    i0.ɵɵelement(7, "img", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 12)(9, "div", 13)(10, "div", 14);
    i0.ɵɵtemplate(11, HeaderComponent_ng_container_0_ng_container_4_fi_template_renderer_11_Template, 1, 1, "fi-template-renderer", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 16)(13, "button", 17);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 18);
    i0.ɵɵtemplate(16, HeaderComponent_ng_container_0_ng_container_4_ng_container_16_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 20)(18, "a", 21);
    i0.ɵɵelement(19, "i", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "a", 23);
    i0.ɵɵelement(21, "i", 24);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(22, "div", 7)(23, "div", 25)(24, "div", 26)(25, "div", 27)(26, "input", 28);
    i0.ɵɵtwoWayListener("ngModelChange", function HeaderComponent_ng_container_0_ng_container_4_Template_input_ngModelChange_26_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.q, $event) || (ctx_r1.q = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keyup.enter", function HeaderComponent_ng_container_0_ng_container_4_Template_input_keyup_enter_26_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.search(ctx_r1.q)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 29)(28, "button", 30);
    i0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ng_container_4_Template_button_click_28_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.search(ctx_r1.q)); });
    i0.ɵɵelement(29, "i", 24);
    i0.ɵɵelementEnd()()()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate1("src", "https://www.fao.org/images/corporatelibraries/fao-logo/fao-logo-", ctx_r1.configService.env.currentLang, ".svg?sfvrsn=f64522b4_36", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.discover);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getLanguageByCode(ctx_r1.configService.env.currentLang));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.configService.env.languages);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("aria-label", ctx_r1.configService.getTranslation("header.search"));
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.configService.getTranslation("header.search"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.q);
    i0.ɵɵattribute("aria-label", ctx_r1.configService.getTranslation("header.search"));
} }
function HeaderComponent_ng_container_0_ng_container_5_a_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 41)(1, "p", 57);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1, "/" + ctx_r1.configService.env.currentLang));
    i0.ɵɵattribute("aria-label", ctx_r1.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.title);
} }
function HeaderComponent_ng_container_0_ng_container_5_a_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 58)(1, "p", 57);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r1.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.title);
} }
function HeaderComponent_ng_container_0_ng_container_5_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59)(1, "button", 60);
    i0.ɵɵelement(2, "i", 61);
    i0.ɵɵelementStart(3, "span", 62);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 63);
    i0.ɵɵelement(6, "i", 64);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("header.search"));
} }
function HeaderComponent_ng_container_0_ng_container_5_fi_login_button_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-login-button", 65);
} }
function HeaderComponent_ng_container_0_ng_container_5_fi_register_button_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-register-button");
} }
function HeaderComponent_ng_container_0_ng_container_5_fi_logout_button_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-logout-button", 66);
} if (rf & 2) {
    i0.ɵɵproperty("header", true);
} }
function HeaderComponent_ng_container_0_ng_container_5_div_21_ng_container_4_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "span", 70);
    i0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ng_container_5_div_21_ng_container_4_li_1_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r5); const lang_r6 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.changeLanguage(lang_r6.code)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const lang_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", !ctx_r1.configService.env.enabledLanguages.includes(lang_r6.code) ? "disabled" : "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(lang_r6.label.toUpperCase());
} }
function HeaderComponent_ng_container_0_ng_container_5_div_21_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_5_div_21_ng_container_4_li_1_Template, 3, 2, "li", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lang_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", lang_r6.code !== ctx_r1.configService.env.currentLang);
} }
function HeaderComponent_ng_container_0_ng_container_5_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 67)(1, "button", 68);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 69);
    i0.ɵɵtemplate(4, HeaderComponent_ng_container_0_ng_container_5_div_21_ng_container_4_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getLanguageByCode(ctx_r1.configService.env.currentLang).toUpperCase());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.configService.env.languages);
} }
function HeaderComponent_ng_container_0_ng_container_5_ul_23_ng_container_1_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 75);
    i0.ɵɵelement(1, "span", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r7 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r1.isActive(child_r7.id, ctx_r1.getMenuItemLink(ctx_r1.getProperty(child_r7, "url"))))("routerLink", i0.ɵɵpureFunction1(4, _c1, ctx_r1.getMenuItemLink(ctx_r1.getProperty(child_r7, "url"))))("target", ctx_r1.getProperty(child_r7, "target") || "_self");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(child_r7, "name"), i0.ɵɵsanitizeHtml);
} }
function HeaderComponent_ng_container_0_ng_container_5_ul_23_ng_container_1_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 73);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_5_ul_23_ng_container_1_li_1_a_1_Template, 2, 6, "a", 74);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r7.id !== "root");
} }
function HeaderComponent_ng_container_0_ng_container_5_ul_23_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_5_ul_23_ng_container_1_li_1_Template, 2, 1, "li", 72);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !child_r7.roles || (child_r7.roles == null ? null : child_r7.roles.includes(ctx_r1.configService.env.roleType)));
} }
function HeaderComponent_ng_container_0_ng_container_5_ul_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 71);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_5_ul_23_ng_container_1_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.configService.env.menu);
} }
function HeaderComponent_ng_container_0_ng_container_5_button_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 77);
    i0.ɵɵelement(1, "i", 61);
    i0.ɵɵelementStart(2, "span", 62);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("header.search"));
} }
function HeaderComponent_ng_container_0_ng_container_5_fi_login_button_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-login-button", 65);
} }
function HeaderComponent_ng_container_0_ng_container_5_fi_register_button_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-register-button");
} }
function HeaderComponent_ng_container_0_ng_container_5_fi_logout_button_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-logout-button", 66);
} if (rf & 2) {
    i0.ɵɵproperty("header", true);
} }
function HeaderComponent_ng_container_0_ng_container_5_div_30_ng_container_4_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "span", 70);
    i0.ɵɵlistener("click", function HeaderComponent_ng_container_0_ng_container_5_div_30_ng_container_4_li_1_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r8); const lang_r9 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.changeLanguage(lang_r9.code)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const lang_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", !ctx_r1.configService.env.enabledLanguages.includes(lang_r9.code) ? "disabled" : "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(lang_r9.label.toUpperCase());
} }
function HeaderComponent_ng_container_0_ng_container_5_div_30_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_ng_container_5_div_30_ng_container_4_li_1_Template, 3, 2, "li", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lang_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", lang_r9.code !== ctx_r1.configService.env.currentLang);
} }
function HeaderComponent_ng_container_0_ng_container_5_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78)(1, "button", 68);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 69);
    i0.ɵɵtemplate(4, HeaderComponent_ng_container_0_ng_container_5_div_30_ng_container_4_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getLanguageByCode(ctx_r1.configService.env.currentLang).toUpperCase());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.configService.env.languages);
} }
function HeaderComponent_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "header", 34)(2, "div", 35)(3, "div", 36)(4, "button", 37);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 38);
    i0.ɵɵelement(6, "path", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(7, "span", 40);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "a", 41);
    i0.ɵɵelement(10, "img", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, HeaderComponent_ng_container_0_ng_container_5_a_11_Template, 3, 5, "a", 43)(12, HeaderComponent_ng_container_0_ng_container_5_a_12_Template, 3, 2, "a", 44)(13, HeaderComponent_ng_container_0_ng_container_5_div_13_Template, 7, 1, "div", 45);
    i0.ɵɵelementStart(14, "div", 46)(15, "div", 47);
    i0.ɵɵtemplate(16, HeaderComponent_ng_container_0_ng_container_5_fi_login_button_16_Template, 1, 0, "fi-login-button", 48)(17, HeaderComponent_ng_container_0_ng_container_5_fi_register_button_17_Template, 1, 0, "fi-register-button", 0)(18, HeaderComponent_ng_container_0_ng_container_5_fi_logout_button_18_Template, 1, 1, "fi-logout-button", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 50);
    i0.ɵɵelement(20, "hr", 51);
    i0.ɵɵtemplate(21, HeaderComponent_ng_container_0_ng_container_5_div_21_Template, 5, 2, "div", 52);
    i0.ɵɵelement(22, "hr", 51);
    i0.ɵɵtemplate(23, HeaderComponent_ng_container_0_ng_container_5_ul_23_Template, 2, 1, "ul", 53);
    i0.ɵɵelement(24, "fi-template-renderer", 31);
    i0.ɵɵelementStart(25, "div", 54);
    i0.ɵɵtemplate(26, HeaderComponent_ng_container_0_ng_container_5_button_26_Template, 4, 1, "button", 55)(27, HeaderComponent_ng_container_0_ng_container_5_fi_login_button_27_Template, 1, 0, "fi-login-button", 48)(28, HeaderComponent_ng_container_0_ng_container_5_fi_register_button_28_Template, 1, 0, "fi-register-button", 0)(29, HeaderComponent_ng_container_0_ng_container_5_fi_logout_button_29_Template, 1, 1, "fi-logout-button", 49)(30, HeaderComponent_ng_container_0_ng_container_5_div_30_Template, 5, 2, "div", 56);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.showSubheader ? "" : "mb-3");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("header.browse"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(20, _c0));
    i0.ɵɵattribute("aria-label", ctx_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("src", "https://www.fao.org/images/corporatelibraries/fao-logo/fao-logo-archive/fao-logo-black-3lines-", ctx_r1.configService.env.currentLang, ".svg", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.homeLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.homeLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSearch);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.configService.isLoggedIn());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.configService.isLoggedIn());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.configService.isLoggedIn());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.showLanguages);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.configService.isLoggedIn());
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r1.applicationHeaderTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showSearch);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.configService.isLoggedIn());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.configService.isLoggedIn());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.configService.isLoggedIn());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showLanguages);
} }
function HeaderComponent_ng_container_0_div_6_ng_container_4_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 85);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.title);
} }
function HeaderComponent_ng_container_0_div_6_ng_container_4_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 86);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.title, " [REVIEW]");
} }
function HeaderComponent_ng_container_0_div_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_div_6_ng_container_4_h2_1_Template, 2, 1, "h2", 83)(2, HeaderComponent_ng_container_0_div_6_ng_container_4_h2_2_Template, 2, 1, "h2", 84);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.configService.env.review);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.configService.env.review);
} }
function HeaderComponent_ng_container_0_div_6_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "fi-template-renderer", 87);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r1.titleHeaderTemplate)("data", i0.ɵɵpureFunction2(2, _c2, ctx_r1.title, ctx_r1.type));
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 99);
    i0.ɵɵelement(1, "i", 100);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c1, ctx_r1.getProperty(child_r10, "url")));
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 101);
    i0.ɵɵelement(1, "i", 100);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r1.getExternalUrl(ctx_r1.getProperty(child_r10, "url")), i0.ɵɵsanitizeUrl)("target", ctx_r1.getProperty(child_r10, "target") || "_self");
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 102);
    i0.ɵɵelement(1, "span", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1, ctx_r1.getProperty(child_r10, "url")))("target", ctx_r1.getProperty(child_r10, "target") || "_self");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(child_r10, "name"), i0.ɵɵsanitizeHtml);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 101);
    i0.ɵɵelement(1, "span", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r1.getExternalUrl(ctx_r1.getProperty(child_r10, "url")), i0.ɵɵsanitizeUrl)("target", ctx_r1.getProperty(child_r10, "target") || "_self");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(child_r10, "name"), i0.ɵɵsanitizeHtml);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 95);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_1_Template, 2, 3, "a", 96)(2, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_2_Template, 2, 2, "a", 97)(3, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_3_Template, 2, 5, "a", 98)(4, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_a_4_Template, 2, 3, "a", 97);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r1.isActive(child_r10.id, ctx_r1.getProperty(child_r10, "url")));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r10.id === "root" && !ctx_r1.getProperty(child_r10, "isExternal"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r10.id === "root" && ctx_r1.getProperty(child_r10, "isExternal"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r10.id !== "root" && !ctx_r1.getProperty(child_r10, "isExternal"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r10.id !== "root" && ctx_r1.getProperty(child_r10, "isExternal"));
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 109);
    i0.ɵɵelement(1, "span", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subchild_r11 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1, ctx_r1.getProperty(subchild_r11, "url")))("target", ctx_r1.getProperty(subchild_r11, "target") || "_self");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(subchild_r11, "name"), i0.ɵɵsanitizeHtml);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 110);
    i0.ɵɵelement(1, "span", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subchild_r11 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("href", ctx_r1.getExternalUrl(ctx_r1.getProperty(subchild_r11, "url")), i0.ɵɵsanitizeUrl)("target", ctx_r1.getProperty(subchild_r11, "target") || "_self");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(subchild_r11, "name"), i0.ɵɵsanitizeHtml);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_1_a_1_Template, 2, 5, "a", 107)(2, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_1_a_2_Template, 2, 3, "a", 108);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subchild_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.getProperty(subchild_r11, "isExternal"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getProperty(subchild_r11, "isExternal"));
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_li_4_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 115);
    i0.ɵɵelement(1, "span", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subsubchild_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(8);
    i0.ɵɵproperty("target", ctx_r1.getProperty(subsubchild_r12, "target") || "_self")("routerLink", i0.ɵɵpureFunction1(4, _c1, ctx_r1.getProperty(subsubchild_r12, "url")))("target", ctx_r1.getProperty(subsubchild_r12, "target") || "_self");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(subsubchild_r12, "name"), i0.ɵɵsanitizeHtml);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_li_4_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 116);
    i0.ɵɵelement(1, "span", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subsubchild_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(8);
    i0.ɵɵproperty("target", ctx_r1.getProperty(subsubchild_r12, "target") || "_self")("href", ctx_r1.getExternalUrl(ctx_r1.getProperty(subsubchild_r12, "url")), i0.ɵɵsanitizeUrl)("target", ctx_r1.getProperty(subsubchild_r12, "target") || "_self");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(subsubchild_r12, "name"), i0.ɵɵsanitizeHtml);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_li_4_a_1_Template, 2, 6, "a", 113)(2, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_li_4_a_2_Template, 2, 4, "a", 114);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subsubchild_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.getProperty(subsubchild_r12, "isExternal"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getProperty(subsubchild_r12, "isExternal"));
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 111)(1, "a", 112);
    i0.ɵɵelement(2, "span", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 69);
    i0.ɵɵtemplate(4, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_li_4_Template, 3, 2, "li", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subchild_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(subchild_r11, "name"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", subchild_r11.items);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_1_Template, 3, 2, "li", 0)(2, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_li_2_Template, 5, 2, "li", 106);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subchild_r11 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !subchild_r11.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", subchild_r11.items);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 103)(1, "a", 104);
    i0.ɵɵelement(2, "span", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 105);
    i0.ɵɵtemplate(4, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_ng_container_4_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const child_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.getProperty(child_r10, "name"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", child_r10.items);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_1_Template, 5, 5, "li", 93)(2, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_li_2_Template, 5, 2, "li", 94);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r10 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !child_r10.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r10.items);
} }
function HeaderComponent_ng_container_0_div_6_nav_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 88)(1, "button", 89);
    i0.ɵɵelement(2, "span", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 91)(4, "nav", 88)(5, "div", 91)(6, "ul", 92);
    i0.ɵɵtemplate(7, HeaderComponent_ng_container_0_div_6_nav_6_ng_container_7_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r1.configService.env.menu);
} }
function HeaderComponent_ng_container_0_div_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 117);
} }
function HeaderComponent_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79)(1, "div", 6)(2, "div", 7)(3, "div", 80);
    i0.ɵɵtemplate(4, HeaderComponent_ng_container_0_div_6_ng_container_4_Template, 3, 2, "ng-container", 0)(5, HeaderComponent_ng_container_0_div_6_ng_container_5_Template, 2, 5, "ng-container", 0)(6, HeaderComponent_ng_container_0_div_6_nav_6_Template, 8, 1, "nav", 81);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, HeaderComponent_ng_container_0_div_6_div_7_Template, 1, 0, "div", 82);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r1.titleHeaderTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.titleHeaderTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.configService.env.menu);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.status === "draft");
} }
function HeaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
    i0.ɵɵelement(3, "div", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, HeaderComponent_ng_container_0_ng_container_4_Template, 30, 9, "ng-container", 0)(5, HeaderComponent_ng_container_0_ng_container_5_Template, 31, 21, "ng-container", 0)(6, HeaderComponent_ng_container_0_div_6_Template, 8, 4, "div", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.type === "site");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.type === "application");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSubheader);
} }
class HeaderComponent {
    constructor(dialogService, router, route, configService, utilsService, languageService, cdr) {
        this.dialogService = dialogService;
        this.router = router;
        this.route = route;
        this.configService = configService;
        this.utilsService = utilsService;
        this.languageService = languageService;
        this.cdr = cdr;
        this.showThemeSwitcher = false;
        this.type = "site";
        this.homeLink = true;
        this.showSubheader = true;
        this.showSearch = true;
        this.showLanguages = true;
        this.onLanguageChange = new EventEmitter();
        this.isCollapsed = true;
        this.external = 'false';
        this.activeChild = {};
    }
    ngAfterViewInit() {
        this.cdr.detectChanges();
    }
    ngOnInit() {
        this.route.queryParams.subscribe(async (params) => {
            this.review = JSON.parse(params.review || "false");
            this.status = params.status;
            if (params.external) {
                this.external = params.external;
            }
            if (this.type === 'site') {
                try {
                    this.discover = await this.configService.loadFile('assets/templates/' + this.type + '/discover_' + this.configService.env.currentLang + '.html', 'text');
                }
                catch (err) {
                }
            }
        });
        window.onscroll = function () { myFunction(); };
        function myFunction() {
            var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            var scrolled = (winScroll / height) * 100;
            document.getElementById("myBar").style.width = scrolled + "%";
        }
        this.router.events.subscribe((val) => {
            if (!this.configService.env.header) {
                this.configService.env.header = {};
            }
            if (val instanceof NavigationEnd) {
                if (val.url === '' || val.url.startsWith('/search')) {
                    this.configService.env.header.showGlobalSearch = false;
                }
                else {
                    this.configService.env.header.showGlobalSearch = true;
                }
            }
        });
    }
    getExternalUrl(url) {
        if (url.startsWith('http')) {
            return url;
        }
        else {
            return this.configService.env.siteUrl + url;
        }
    }
    isActive(id, url, show) {
        if (id === this.activeMenuId || (url > '' && this.router.url.includes(url))) {
            return show ? 'show' : 'active';
        }
        else {
            return 'inactive';
        }
    }
    changeLanguage(lang) {
        this.languageService.changeLanguage(lang);
        this.onLanguageChange.emit(lang);
    }
    search(event) {
        /*     if (event.query !== '') {
              this.router.navigate(['/' + this.configService.env.currentLang + '/global-search'], { queryParams: {q: event.query, lang: event.lang}});
            } */
        window.location.href = "https://www.fao.org/home/search/" + this.configService.env.currentLang + "/?q=" + event;
    }
    getTabClass(groups) {
        let n = Math.round(12 / groups.length);
        return "col-lg-" + n + " tab";
    }
    register() {
        const ref = this.dialogService.open(UserRegisterComponent, {
            header: 'Registration',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    getMenuItemLink(url) {
        return url.replace("${space}", this.configService.env.space);
    }
    getProperty(child, prop) {
        let item = (child[this.configService.env.currentLang] || child[this.configService.env.defaultLang]);
        if (item) {
            return item[prop];
        }
        else {
            return "";
        }
    }
    static { this.ɵfac = function HeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HeaderComponent)(i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.LanguageService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["fao-header"]], inputs: { showThemeSwitcher: "showThemeSwitcher", title: "title", type: "type", homeLink: "homeLink", showSubheader: "showSubheader", showSearch: "showSearch", showLanguages: "showLanguages", titleHeaderTemplate: "titleHeaderTemplate", applicationHeaderTemplate: "applicationHeaderTemplate" }, outputs: { onLanguageChange: "onLanguageChange" }, standalone: false, decls: 2, vars: 1, consts: [[4, "ngIf"], [1, "header"], [1, "progress-container"], ["id", "myBar", 1, "progress-bar"], ["class", "subheader", 4, "ngIf"], [1, "fao-header", "subsite-header"], [1, "container"], [1, "row"], [1, "header-wrapper", "col-12"], [1, "fao-header-left"], ["href", "/"], ["alt", "Food and Agriculture Organization of the United Nations", "title", "Food and Agriculture Organization of the United Nations", 1, "header-fao-logo", 3, "src"], [1, "fao-header-right"], [1, "row", "discover"], [1, "col-md-12"], [3, "template", 4, "ngIf"], ["aria-label", "Change Language", "role", "menu", 1, "dropdown", "language-switch"], ["type", "button", "id", "dropdownLanguageMenu", "data-bs-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn", "btn-secondary", "dropdown-toggle"], ["aria-labelledby", "dropdownLanguageMenu", 1, "dropdown-menu"], [4, "ngFor", "ngForOf"], [1, "header-icons"], ["href", "javascript:void(0)", "type", "button", "data-bs-toggle", "modal", "data-bs-target", "#shareModal", "aria-label", "Share"], [1, "bi", "bi-share-fill"], ["data-bs-toggle", "collapse", "href", "#collapseExample", "role", "button", "aria-expanded", "false", "aria-controls", "collapseExample"], [1, "bi", "bi-search"], [1, "col-12"], ["id", "collapseExample", 1, "collapse"], [1, "input-group", "my-3"], ["type", "text", 1, "form-control", 3, "ngModelChange", "keyup.enter", "placeholder", "ngModel"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-primary", "btn-icon", 3, "click"], [3, "template"], ["class", "dropdown-item", "href", "javascript:void(0)", "role", "menuitem", 3, "ngClass", "click", 4, "ngIf"], ["href", "javascript:void(0)", "role", "menuitem", 1, "dropdown-item", 3, "click", "ngClass"], [1, "navbar", "navbar-expand-lg", "navbar-dark", "app-navbar", "bg-white", "sticky-top", 3, "ngClass"], ["aria-label", "Main navigation", 1, "container-fluid", "flex-wrap", "flex-lg-nowrap"], [1, "bd-navbar-toggle"], ["type", "button", "data-bs-toggle", "offcanvas", "data-bs-target", "#bdSidebar", "aria-controls", "bdSidebar", "aria-label", "Toggle docs navigation", 1, "navbar-toggler", "p-2", "border-0"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "fill", "currentColor", "viewBox", "0 0 16 16", 1, "bi"], ["fill-rule", "evenodd", "d", "M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"], [1, "d-none", "fs-6", "pe-1"], [1, "navbar-brand", "p-0", "me-0", "me-lg-4", "d-flex", "align-items-center", 3, "routerLink"], ["alt", "FAO logo", "width", "100%", "height", "40px", 1, "", 3, "src"], ["class", "navbar-brand p-0 me-0 me-lg-4 d-flex align-items-center", 3, "routerLink", 4, "ngIf"], ["class", "navbar-brand p-0 me-0 me-lg-4 d-flex align-items-center", 4, "ngIf"], ["class", "d-flex", 4, "ngIf"], ["tabindex", "-1", "id", "bdNavbar", "aria-labelledby", "bdNavbarOffcanvasLabel", "data-bs-scroll", "true", 1, "offcanvas-lg", "offcanvas-end", "flex-grow-1", "bg-white"], [1, "offcanvas-header", "px-4", "pb-0"], ["variant", "text", 4, "ngIf"], [3, "header", 4, "ngIf"], [1, "offcanvas-body", "pt-0", "p-lg-0"], [1, "d-lg-none"], ["class", "dropdown d-lg-none", 4, "ngIf"], ["class", "navbar-nav flex-row bd-navbar-nav flex-wrap", 4, "ngIf"], [1, "flex-row", "ms-md-auto", "align-items-center", "d-none", "d-lg-flex", "justify-content-end", "nav-link"], ["class", "btn btn-search btn-icon btn-icon-s btn-sm text-decoration-none text-color-gray-dark me-xl-2", "data-bs-toggle", "modal", "data-bs-target", "#exampleModal", 4, "ngIf"], ["class", "dropdown ps-2", 4, "ngIf"], [1, "ms-3", "mb-0", "border-start", "ps-3", "nav-link", "fw-semibold", "d-none", "d-lg-block"], [1, "navbar-brand", "p-0", "me-0", "me-lg-4", "d-flex", "align-items-center"], [1, "d-flex"], ["href", "javascript:void(0)", "data-bs-toggle", "modal", "data-bs-target", "#exampleModal", 1, "btn", "btn-search", "btn-icon", "btn-icon-s", "btn-sm", "text-decoration-none", "text-color-gray-dark", "me-xl-2", "d-lg-none"], [1, "bi", "bi-search", "m-0", "me-xl-2"], [1, "d-none", "d-xl-inline"], ["type", "button", "data-bs-toggle", "offcanvas", "data-bs-target", "#bdNavbar", "aria-controls", "bdNavbar", "aria-label", "Toggle navigation", 1, "navbar-toggler", "d-flex", "d-lg-none", "order-3", "p-2", "border-0"], [1, "bi", "bi-three-dots"], ["variant", "text"], [3, "header"], [1, "dropdown", "d-lg-none"], ["type", "button", "data-bs-toggle", "dropdown", "aria-expanded", "false", 1, "btn", "bg-gray-light", "btn-sm", "dropdown-toggle"], [1, "dropdown-menu"], [1, "dropdown-item", 3, "click", "ngClass"], [1, "navbar-nav", "flex-row", "bd-navbar-nav", "flex-wrap"], ["class", "nav-item col-6 col-lg-auto", 4, "ngIf"], [1, "nav-item", "col-6", "col-lg-auto"], ["class", "nav-link py-2 px-0 px-lg-2", 3, "ngClass", "routerLink", "target", 4, "ngIf"], [1, "nav-link", "py-2", "px-0", "px-lg-2", 3, "ngClass", "routerLink", "target"], [3, "innerHTML"], ["data-bs-toggle", "modal", "data-bs-target", "#exampleModal", 1, "btn", "btn-search", "btn-icon", "btn-icon-s", "btn-sm", "text-decoration-none", "text-color-gray-dark", "me-xl-2"], [1, "dropdown", "ps-2"], [1, "subheader"], [1, "col-md-12", "mb-2"], ["class", "navbar-subsite navbar navbar-expand-lg navbar-light bg-white undefined", 4, "ngIf"], ["class", "draft mb-2", 4, "ngIf"], ["class", "page-title", 4, "ngIf"], ["class", "page-title bg-emergency text-color-white-fao", 4, "ngIf"], [1, "page-title"], [1, "page-title", "bg-emergency", "text-color-white-fao"], [3, "template", "data"], [1, "navbar-subsite", "navbar", "navbar-expand-lg", "navbar-light", "bg-white", "undefined"], ["type", "button", "data-bs-toggle", "collapse", "data-bs-target", "#navbarSupportedContent", "aria-controls", "navbarSupportedContent", "aria-expanded", "false", "aria-label", "Toggle navigation", 1, "navbar-toggler"], [1, "navbar-toggler-icon"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav", "me-auto"], ["class", "nav-item", 3, "ngClass", 4, "ngIf"], ["class", "nav-item dropdown", 4, "ngIf"], [1, "nav-item", 3, "ngClass"], ["class", "nav-link", 3, "routerLink", 4, "ngIf"], ["class", "nav-link", 3, "href", "target", 4, "ngIf"], ["class", "nav-link", 3, "routerLink", "target", 4, "ngIf"], [1, "nav-link", 3, "routerLink"], [1, "bi", "bi-house-fill"], [1, "nav-link", 3, "href", "target"], [1, "nav-link", 3, "routerLink", "target"], [1, "nav-item", "dropdown"], ["id", "navbarDropdown", "role", "button", "data-bs-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "nav-link", "dropdown-toggle"], ["aria-labelledby", "navbarDropdown", 1, "dropdown-menu"], ["class", "dropdown-submenu", 4, "ngIf"], ["class", "dropdown-item", 3, "routerLink", "target", 4, "ngIf"], ["class", "dropdown-item", 3, "href", "target", 4, "ngIf"], [1, "dropdown-item", 3, "routerLink", "target"], [1, "dropdown-item", 3, "href", "target"], [1, "dropdown-submenu"], [1, "dropdown-item", "dropdown-toggle"], ["class", "dropdown-item", 3, "target", "routerLink", 4, "ngIf"], ["class", "dropdown-item", 3, "target", "href", 4, "ngIf"], [1, "dropdown-item", 3, "target", "routerLink"], [1, "dropdown-item", 3, "target", "href"], [1, "draft", "mb-2"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, HeaderComponent_ng_container_0_Template, 7, 3, "ng-container", 0);
            i0.ɵɵelement(1, "fi-share-modal");
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.external || ctx.external === "false");
        } }, dependencies: [i4$1.NgClass, i4$1.NgForOf, i4$1.NgIf, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i2.RouterLink, i4.LoginButtonComponent, i4.RegisterButtonComponent, i4.LogoutButtonComponent, i4.TemplateRendererComponent, i4.ShareModalComponent], styles: [".header-login[_ngcontent-%COMP%]{background:none!important}.discover[_ngcontent-%COMP%]{width:100%}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{ selector: 'fao-header', standalone: false, template: "<ng-container *ngIf=\"!external || external === 'false'\">\r\n\r\n  <div class=\"header\">\r\n    <div class=\"progress-container\">\r\n      <div class=\"progress-bar\" id=\"myBar\"></div>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"type === 'site'\">\r\n    <header class=\"fao-header subsite-header\">\r\n      <div class=\"container\">\r\n        <div class=\"row\">\r\n          <div class=\"header-wrapper col-12\">\r\n            <div class=\"fao-header-left\">\r\n              <a href=\"/\">\r\n                <img src=\"https://www.fao.org/images/corporatelibraries/fao-logo/fao-logo-{{configService.env.currentLang}}.svg?sfvrsn=f64522b4_36\"\r\n                  alt=\"Food and Agriculture Organization of the United Nations\"\r\n                  title=\"Food and Agriculture Organization of the United Nations\" class=\"header-fao-logo\">\r\n              </a>\r\n            </div>\r\n    \r\n            <div class=\"fao-header-right\">\r\n              <div class=\"row discover\">\r\n                <div class=\"col-md-12\">\r\n                  <fi-template-renderer *ngIf=\"discover\" [template]=\"discover\"></fi-template-renderer>\r\n                </div>\r\n              </div>\r\n    \r\n              <div class=\"dropdown language-switch\" aria-label=\"Change Language\" role=\"menu\">\r\n                <button class=\"btn btn-secondary dropdown-toggle\" type=\"button\" id=\"dropdownLanguageMenu\" data-bs-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{configService.getLanguageByCode(configService.env.currentLang)}}</button>\r\n    \r\n                <div class=\"dropdown-menu\" aria-labelledby=\"dropdownLanguageMenu\">\r\n                  <ng-container *ngFor=\"let lang of configService.env.languages\">\r\n                    <a *ngIf=\"lang.code !== configService.env.currentLang\" [ngClass]=\"!configService.env.enabledLanguages.includes(lang.code) ? 'disabled' : ''\" class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"changeLanguage(lang.code)\" role=\"menuitem\" [attr.aria-label]=\"lang.label\">{{lang.label}}</a>\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n    \r\n              <div class=\"header-icons\">\r\n                <a href=\"javascript:void(0)\" type=\"button\" data-bs-toggle=\"modal\" data-bs-target=\"#shareModal\" aria-label=\"Share\">\r\n                  <i class=\"bi bi-share-fill\"></i>\r\n                </a>\r\n    \r\n                <a data-bs-toggle=\"collapse\" href=\"#collapseExample\" role=\"button\" aria-expanded=\"false\"\r\n                  aria-controls=\"collapseExample\" attr.aria-label=\"{{configService.getTranslation('header.search')}}\">\r\n                  <i class=\"bi bi-search\"></i>\r\n                </a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n    \r\n        <div class=\"row\">\r\n          <div class=\"col-12\">\r\n            <div class=\"collapse\" id=\"collapseExample\">\r\n              <div class=\"input-group my-3\">\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{configService.getTranslation('header.search')}}\" attr.aria-label=\"{{configService.getTranslation('header.search')}}\" [(ngModel)]=\"q\" (keyup.enter)=\"search(q)\" />\r\n    \r\n                <div class=\"input-group-append\">\r\n                  <button type=\"button\" class=\"btn btn-primary btn-icon\" (click)=\"search(q)\">\r\n                    <i class=\"bi bi-search\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </header>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"type === 'application'\">\r\n    <header class=\"navbar navbar-expand-lg navbar-dark app-navbar bg-white sticky-top\" [ngClass]=\"showSubheader ? '' : 'mb-3'\">\r\n      <div class=\"container-fluid flex-wrap flex-lg-nowrap\" aria-label=\"Main navigation\">\r\n        <div class=\"bd-navbar-toggle\"><button class=\"navbar-toggler p-2 border-0\" type=\"button\" data-bs-toggle=\"offcanvas\"\r\n            data-bs-target=\"#bdSidebar\" aria-controls=\"bdSidebar\" aria-label=\"Toggle docs navigation\"><svg\r\n              xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" class=\"bi\" fill=\"currentColor\" viewBox=\"0 0 16 16\">\r\n              <path fill-rule=\"evenodd\"\r\n                d=\"M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z\">\r\n              </path>\r\n            </svg><span class=\"d-none fs-6 pe-1\">{{configService.getTranslation('header.browse')}}</span></button></div>\r\n            <a class=\"navbar-brand p-0 me-0 me-lg-4 d-flex align-items-center\" [routerLink]=\"['/']\" attr.aria-label=\"{{title}}\">\r\n              <img src=\"https://www.fao.org/images/corporatelibraries/fao-logo/fao-logo-archive/fao-logo-black-3lines-{{configService.env.currentLang}}.svg\" alt=\"FAO logo\" width=\"100%\" height=\"40px\" class=\"\">\r\n            </a>\r\n            <a *ngIf=\"homeLink\" class=\"navbar-brand p-0 me-0 me-lg-4 d-flex align-items-center\" [routerLink]=\"['/' + configService.env.currentLang ]\" attr.aria-label=\"{{title}}\">\r\n              <p class=\"ms-3 mb-0 border-start ps-3 nav-link fw-semibold d-none d-lg-block\">{{title}}</p>\r\n            </a>\r\n            <a *ngIf=\"!homeLink\" class=\"navbar-brand p-0 me-0 me-lg-4 d-flex align-items-center\" attr.aria-label=\"{{title}}\">\r\n              <p class=\"ms-3 mb-0 border-start ps-3 nav-link fw-semibold d-none d-lg-block\">{{title}}</p>\r\n            </a>\r\n\r\n\r\n        <div *ngIf=\"showSearch\" class=\"d-flex\"><button href=\"javascript:void(0)\"\r\n            class=\"btn btn-search btn-icon btn-icon-s btn-sm text-decoration-none text-color-gray-dark me-xl-2 d-lg-none\"\r\n            data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal\"><i class=\"bi bi-search m-0 me-xl-2\"></i><span\r\n              class=\"d-none d-xl-inline\">{{configService.getTranslation('header.search')}}</span></button><button\r\n            class=\"navbar-toggler d-flex d-lg-none order-3 p-2 border-0\" type=\"button\" data-bs-toggle=\"offcanvas\"\r\n            data-bs-target=\"#bdNavbar\" aria-controls=\"bdNavbar\" aria-label=\"Toggle navigation\"><i\r\n              class=\"bi bi-three-dots\"></i></button></div>\r\n        <div class=\"offcanvas-lg offcanvas-end flex-grow-1 bg-white\" tabindex=\"-1\" id=\"bdNavbar\"\r\n          aria-labelledby=\"bdNavbarOffcanvasLabel\" data-bs-scroll=\"true\">\r\n          <div class=\"offcanvas-header px-4 pb-0\">\r\n            <fi-login-button *ngIf=\"!configService.isLoggedIn()\" variant=\"text\"></fi-login-button>\r\n            <fi-register-button *ngIf=\"!configService.isLoggedIn()\"></fi-register-button>\r\n            <fi-logout-button *ngIf=\"configService.isLoggedIn()\" [header]=\"true\"></fi-logout-button>\r\n          </div>\r\n          <div class=\"offcanvas-body pt-0 p-lg-0\">\r\n            <hr class=\"d-lg-none\" />\r\n            <div *ngIf=\"showLanguages\" class=\"dropdown d-lg-none\"><button class=\"btn bg-gray-light btn-sm dropdown-toggle\" type=\"button\"\r\n                data-bs-toggle=\"dropdown\" aria-expanded=\"false\">{{configService.getLanguageByCode(configService.env.currentLang).toUpperCase()}}</button>\r\n              <ul class=\"dropdown-menu\">\r\n                <ng-container *ngFor=\"let lang of configService.env.languages\">\r\n                  <li *ngIf=\"lang.code !== configService.env.currentLang\"><span [ngClass]=\"!configService.env.enabledLanguages.includes(lang.code) ? 'disabled' : ''\" class=\"dropdown-item\" (click)=\"changeLanguage(lang.code)\">{{lang.label.toUpperCase()}}</span></li>\r\n                </ng-container>\r\n              </ul>\r\n            </div>\r\n            <hr class=\"d-lg-none\" />\r\n            \r\n            <ul class=\"navbar-nav flex-row bd-navbar-nav flex-wrap\" *ngIf=\"configService.isLoggedIn()\">\r\n              <ng-container *ngFor=\"let child of configService.env.menu\">\r\n                <li class=\"nav-item col-6 col-lg-auto\" *ngIf=\"!child.roles || child.roles?.includes(configService.env.roleType)\">\r\n                  <a *ngIf=\"child.id !== 'root'\" class=\"nav-link py-2 px-0 px-lg-2\" [ngClass]=\"isActive(child.id, getMenuItemLink(getProperty(child,'url')))\"\r\n                  [routerLink]=\"[getMenuItemLink(getProperty(child,'url'))]\"\r\n                  [target]=\"getProperty(child,'target') || '_self'\"><span innerHTML=\"{{ getProperty(child,'name') }}\"></span></a>\r\n                </li>\r\n              </ng-container>\r\n            </ul>\r\n\r\n            <fi-template-renderer [template]=\"applicationHeaderTemplate\"></fi-template-renderer>\r\n    \r\n            <div class=\"flex-row ms-md-auto align-items-center d-none d-lg-flex justify-content-end nav-link\">\r\n              <button *ngIf=\"showSearch\" class=\"btn btn-search btn-icon btn-icon-s btn-sm text-decoration-none text-color-gray-dark me-xl-2\"\r\n                data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal\"><i class=\"bi bi-search m-0 me-xl-2\"></i><span\r\n                  class=\"d-none d-xl-inline\">{{configService.getTranslation('header.search')}}</span></button>\r\n    \r\n              <fi-login-button *ngIf=\"!configService.isLoggedIn()\" variant=\"text\"></fi-login-button>\r\n              <fi-register-button *ngIf=\"!configService.isLoggedIn()\"></fi-register-button>\r\n              <fi-logout-button *ngIf=\"configService.isLoggedIn()\" [header]=\"true\"></fi-logout-button>\r\n              \r\n              <!-- <button type=\"button\" class=\"btn-close\" *ngIf=\"configService.isLoggedIn()\"\r\n                data-bs-dismiss=\"offcanvas\" aria-label=\"Close\" data-bs-target=\"#bdNavbar\" (click)=\"configService.logout()\"></button> -->\r\n        \r\n              <div *ngIf=\"showLanguages\" class=\"dropdown ps-2\"><button class=\"btn bg-gray-light btn-sm dropdown-toggle\" type=\"button\"\r\n                  data-bs-toggle=\"dropdown\" aria-expanded=\"false\">{{configService.getLanguageByCode(configService.env.currentLang).toUpperCase()}}</button>\r\n                <ul class=\"dropdown-menu\">\r\n                  <ng-container *ngFor=\"let lang of configService.env.languages\">\r\n                    <li *ngIf=\"lang.code !== configService.env.currentLang\"><span [ngClass]=\"!configService.env.enabledLanguages.includes(lang.code) ? 'disabled' : ''\" class=\"dropdown-item\" (click)=\"changeLanguage(lang.code)\">{{lang.label.toUpperCase()}}</span></li>\r\n                  </ng-container>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </header>\r\n  </ng-container>\r\n  \r\n  <div class=\"subheader\" *ngIf=\"showSubheader\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12 mb-2\">\r\n          <ng-container *ngIf=\"!titleHeaderTemplate\">\r\n            <h2 class=\"page-title\" *ngIf=\"!configService.env.review\">{{ title }}</h2>\r\n            <h2 class=\"page-title bg-emergency text-color-white-fao\" *ngIf=\"configService.env.review\">{{ title }} [REVIEW]</h2>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"titleHeaderTemplate\">\r\n            <fi-template-renderer [template]=\"titleHeaderTemplate\" [data]=\"{ title: title, type: type }\"></fi-template-renderer>\r\n          </ng-container>\r\n\r\n          <nav class=\"navbar-subsite navbar navbar-expand-lg navbar-light bg-white undefined\" *ngIf=\"configService.env.menu\">\r\n            <!-- Button for low resolutions -->\r\n            <button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-icon\"></span></button>\r\n            \r\n            <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\r\n\r\n              <nav class=\"navbar-subsite navbar navbar-expand-lg navbar-light bg-white undefined\">\r\n\r\n                <!-- Menu structure -->\r\n                <div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\">\r\n                  <ul class=\"navbar-nav me-auto\">\r\n\r\n                    <ng-container *ngFor=\"let child of configService.env.menu\">\r\n                      <!-- Menu item without children -->\r\n                      <li *ngIf=\"!child.items\" class=\"nav-item\" [ngClass]=\"isActive(child.id, getProperty(child,'url'))\">\r\n                        <a *ngIf=\"child.id === 'root' && !getProperty(child,'isExternal')\"\r\n                          class=\"nav-link\" [routerLink]=\"[getProperty(child,'url')]\"><i class=\"bi bi-house-fill\"></i></a>\r\n                        <a *ngIf=\"child.id === 'root' && getProperty(child,'isExternal')\"\r\n                          class=\"nav-link\" [href]=\"getExternalUrl(getProperty(child,'url'))\"\r\n                          [target]=\"getProperty(child,'target') || '_self'\"><i class=\"bi bi-house-fill\"></i></a>\r\n                        <a *ngIf=\"child.id !== 'root' && !getProperty(child,'isExternal')\" class=\"nav-link\"\r\n                          [routerLink]=\"[getProperty(child,'url')]\"\r\n                          [target]=\"getProperty(child,'target') || '_self'\"><span innerHTML=\"{{ getProperty(child,'name') }}\"></span></a>\r\n                        <a *ngIf=\"child.id !== 'root' && getProperty(child,'isExternal')\" class=\"nav-link\"\r\n                          [href]=\"getExternalUrl(getProperty(child,'url'))\"\r\n                          [target]=\"getProperty(child,'target') || '_self'\"><span innerHTML=\"{{ getProperty(child,'name') }}\"></span></a>\r\n                      </li>\r\n\r\n                      <!-- Menu item with children -->\r\n                      <li *ngIf=\"child.items\" class=\"nav-item dropdown\">\r\n                        <a class=\"nav-link dropdown-toggle\" id=\"navbarDropdown\" role=\"button\" data-bs-toggle=\"dropdown\"\r\n                          aria-haspopup=\"true\" aria-expanded=\"false\"><span innerHTML=\"{{ getProperty(child,'name') }}\"></span></a>\r\n                        <ul class=\"dropdown-menu\" aria-labelledby=\"navbarDropdown\">\r\n\r\n                          <ng-container *ngFor=\"let subchild of child.items\">\r\n                            <li *ngIf=\"!subchild.items\">\r\n                              <a *ngIf=\"!getProperty(subchild,'isExternal')\" class=\"dropdown-item\"\r\n                                [routerLink]=\"[getProperty(subchild,'url')]\"\r\n                                [target]=\"getProperty(subchild,'target') || '_self'\"><span innerHTML=\"{{ getProperty(subchild,'name') }}\"></span></a>\r\n                              <a *ngIf=\"getProperty(subchild,'isExternal')\" class=\"dropdown-item\"\r\n                                [href]=\"getExternalUrl(getProperty(subchild,'url'))\"\r\n                                [target]=\"getProperty(subchild,'target') || '_self'\"><span innerHTML=\"{{ getProperty(subchild,'name') }}\"></span></a>\r\n                            </li>\r\n                            <li *ngIf=\"subchild.items\" class=\"dropdown-submenu\">\r\n                              <a class=\"dropdown-item dropdown-toggle\"><span innerHTML=\"{{ getProperty(subchild,'name') }}\"></span></a>\r\n                              <ul class=\"dropdown-menu\">\r\n                                <li *ngFor=\"let subsubchild of subchild.items\">\r\n                                  <a *ngIf=\"!getProperty(subsubchild,'isExternal')\"\r\n                                    class=\"dropdown-item\"\r\n                                    [target]=\"getProperty(subsubchild,'target') || '_self'\"\r\n                                    [routerLink]=\"[getProperty(subsubchild,'url')]\"\r\n                                    [target]=\"getProperty(subsubchild,'target') || '_self'\"><span innerHTML=\"{{ getProperty(subsubchild,'name') }}\"></span></a>\r\n                                  <a *ngIf=\"getProperty(subsubchild,'isExternal')\"\r\n                                    class=\"dropdown-item\"\r\n                                    [target]=\"getProperty(subsubchild,'target') || '_self'\"\r\n                                    [href]=\"getExternalUrl(getProperty(subsubchild,'url'))\"\r\n                                    [target]=\"getProperty(subsubchild,'target') || '_self'\"><span innerHTML=\"{{ getProperty(subsubchild,'name') }}\"></span></a>\r\n                                </li>\r\n                              </ul>\r\n                            </li>\r\n                          </ng-container>\r\n\r\n                        </ul>\r\n                      </li>\r\n                    </ng-container>\r\n\r\n                  </ul>\r\n                </div>\r\n              </nav>\r\n            </div>\r\n          </nav>\r\n        </div>\r\n      </div>\r\n      <div class=\"draft mb-2\" *ngIf=\"status === 'draft'\">\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</ng-container>\r\n\r\n<fi-share-modal></fi-share-modal>", styles: [".header-login{background:none!important}.discover{width:100%}\n"] }]
    }], () => [{ type: i1$1.DialogService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.ConfigurationService }, { type: i1.UtilsService }, { type: i1.LanguageService }, { type: i0.ChangeDetectorRef }], { showThemeSwitcher: [{
            type: Input
        }], title: [{
            type: Input
        }], type: [{
            type: Input
        }], homeLink: [{
            type: Input
        }], showSubheader: [{
            type: Input
        }], showSearch: [{
            type: Input
        }], showLanguages: [{
            type: Input
        }], titleHeaderTemplate: [{
            type: Input
        }], applicationHeaderTemplate: [{
            type: Input
        }], onLanguageChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HeaderComponent, { className: "HeaderComponent", filePath: "src/fao/header/header.component.ts", lineNumber: 13 }); })();

function JsonViewerComponent_ngx_json_viewer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ngx-json-viewer", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("json", ctx_r0.formData);
} }
class JsonViewerComponent {
    constructor(ref, config) {
        this.ref = ref;
        this.config = config;
        this.pageReady = false;
    }
    ngOnInit() {
        if (this.config && this.config.data) {
            this.formData = this.config.data.formData;
            this.pageReady = true;
        }
    }
    download() {
        var sJson = JSON.stringify(this.formData);
        var element = document.createElement('a');
        element.setAttribute('href', "data:text/json;charset=UTF-8," + encodeURIComponent(sJson));
        element.setAttribute('download', "formdata.json");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    static { this.ɵfac = function JsonViewerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || JsonViewerComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: JsonViewerComponent, selectors: [["json-viewer"]], standalone: false, decls: 5, vars: 2, consts: [[1, "row"], [1, "col-md-12", "form-data-modal"], [3, "json", 4, "ngIf"], [1, "col-md-12", "mt-3", "align-right"], ["icon", "bi bi-download", "severity", "secondary", "title", "Download", 3, "click", "rounded"], [3, "json"]], template: function JsonViewerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, JsonViewerComponent_ngx_json_viewer_2_Template, 1, 1, "ngx-json-viewer", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "p-button", 4);
            i0.ɵɵlistener("click", function JsonViewerComponent_Template_p_button_click_4_listener() { return ctx.download(); });
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.formData);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("rounded", true);
        } }, dependencies: [i4$1.NgIf, i3$1.NgxJsonViewerComponent, i4$2.Button], styles: [".form-data-modal[_ngcontent-%COMP%]{max-height:50vh!important;overflow:auto}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonViewerComponent, [{
        type: Component,
        args: [{ selector: 'json-viewer', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-12 form-data-modal\">\r\n        <ngx-json-viewer *ngIf=\"formData\" [json]=\"formData\"></ngx-json-viewer>\r\n    </div>\r\n    <div class=\"col-md-12 mt-3 align-right\">\r\n        <p-button icon=\"bi bi-download\" [rounded]=\"true\" severity=\"secondary\" title=\"Download\" (click)=\"download()\"></p-button>\r\n    </div>\r\n</div>", styles: [".form-data-modal{max-height:50vh!important;overflow:auto}\n"] }]
    }], () => [{ type: i1$1.DynamicDialogRef }, { type: i1$1.DynamicDialogConfig }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JsonViewerComponent, { className: "JsonViewerComponent", filePath: "src/data-editor/components/json-viewer/json-viewer.component.ts", lineNumber: 10 }); })();

function RoutesManagerComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "collection-item", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.collection)("alias", ctx_r0.alias)("editing", ctx_r0.editing);
} }
function RoutesManagerComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "list-page", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("space", ctx_r0.space)("name", ctx_r0.collection);
} }
function RoutesManagerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RoutesManagerComponent_ng_container_0_ng_container_1_Template, 2, 4, "ng-container", 0)(2, RoutesManagerComponent_ng_container_0_ng_container_2_Template, 2, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.alias);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.alias);
} }
class RoutesManagerComponent {
    constructor(cacheService, configService, utilsService, route, router) {
        this.cacheService = cacheService;
        this.configService = configService;
        this.utilsService = utilsService;
        this.route = route;
        this.router = router;
        this.restricted = false;
        this.editing = false;
        this.pageReady = false;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }
    ngOnInit() {
        this.init();
    }
    async init() {
        await this.configService.getConfigurations();
        this.currentRoute = this.configService.findRoute(this.router.url);
        if (this.currentRoute) {
            this.space = this.configService.env.space;
            this.collection = this.currentRoute.collection;
            this.restricted = this.currentRoute.restricted;
            this.editing = this.currentRoute.editing;
            this.alias = this.currentRoute.alias;
        }
        else {
            let url = this.router.url.substring(1).substring(this.router.url.substring(1).indexOf('/'));
            url = url.split("?")[0];
            url = url.substring(1, url.length);
            this.space = this.configService.env.space;
            this.collection = "pages";
            this.editing = false;
            this.alias = url;
        }
        this.pageReady = true;
    }
    static { this.ɵfac = function RoutesManagerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RoutesManagerComponent)(i0.ɵɵdirectiveInject(i1.CacheService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RoutesManagerComponent, selectors: [["routes-manager"]], standalone: false, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "space", "collection", "alias", "editing"], [3, "space", "name"]], template: function RoutesManagerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, RoutesManagerComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pageReady);
        } }, dependencies: [i4$1.NgIf, i4.CollectionItemComponent, ListPageComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoutesManagerComponent, [{
        type: Component,
        args: [{ selector: 'routes-manager', standalone: false, template: "<ng-container *ngIf=\"pageReady\">\r\n    <ng-container *ngIf=\"alias\">\r\n        <collection-item [space]=\"space\" [collection]=\"collection\" [alias]=\"alias\" [editing]=\"editing\"></collection-item>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!alias\">\r\n        <list-page [space]=\"space\" [name]=\"collection\"></list-page>\r\n    </ng-container>\r\n</ng-container>" }]
    }], () => [{ type: i1.CacheService }, { type: i1.ConfigurationService }, { type: i1.UtilsService }, { type: i2.ActivatedRoute }, { type: i2.Router }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(RoutesManagerComponent, { className: "RoutesManagerComponent", filePath: "src/routes-manager/routes-manager.component.ts", lineNumber: 12 }); })();

class RequestAccessComponent {
    static { this.ɵfac = function RequestAccessComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RequestAccessComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RequestAccessComponent, selectors: [["request-access"]], standalone: false, decls: 2, vars: 0, template: function RequestAccessComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "p");
            i0.ɵɵtext(1, "request-access works!");
            i0.ɵɵelementEnd();
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequestAccessComponent, [{
        type: Component,
        args: [{ selector: 'request-access', standalone: false, template: "<p>request-access works!</p>\r\n" }]
    }], null, null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(RequestAccessComponent, { className: "RequestAccessComponent", filePath: "src/request-access/request-access.component.ts", lineNumber: 9 }); })();

function createCompiler(compilerFactory) {
    return compilerFactory.createCompiler();
}
const reporting_components = [
    DetailPageComponent,
    JsonViewerComponent,
    ListPageComponent,
    ReportingComponent,
    TestListPageComponent,
    RoutesManagerComponent
];
const data_editor_components = [
    DataEditorComponent
];
class LightformsCoreModule {
    static forRoot(env) {
        return {
            ngModule: LightformsCoreModule,
            providers: [ConfigurationService, { provide: 'env', useValue: env }]
        };
    }
    static { this.ɵfac = function LightformsCoreModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LightformsCoreModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LightformsCoreModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            { provide: COMPILER_OPTIONS, useValue: {}, multi: true },
            { provide: CompilerFactory, useClass: JitCompilerFactory, deps: [COMPILER_OPTIONS] },
            { provide: Compiler, useFactory: createCompiler, deps: [CompilerFactory] },
            {
                provide: APP_INITIALIZER,
                multi: true,
                useFactory: (config) => {
                    return () => {
                        config.load();
                    };
                },
                deps: [ConfigurationService],
            }
        ], imports: [CommonModule,
            FormsModule,
            RouterModule,
            ReactiveFormsModule,
            ClipboardModule,
            NgxJsonViewerModule,
            LightformsComponentsModule,
            LightformsServicesModule, CommonModule,
            FormsModule,
            ReactiveFormsModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightformsCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    HeaderComponent,
                    FooterComponent,
                    reporting_components,
                    data_editor_components,
                    RequestAccessComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    RouterModule,
                    ReactiveFormsModule,
                    ClipboardModule,
                    NgxJsonViewerModule,
                    LightformsComponentsModule,
                    LightformsServicesModule
                ],
                exports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    HeaderComponent,
                    FooterComponent,
                    reporting_components,
                    data_editor_components
                ],
                providers: [
                    { provide: COMPILER_OPTIONS, useValue: {}, multi: true },
                    { provide: CompilerFactory, useClass: JitCompilerFactory, deps: [COMPILER_OPTIONS] },
                    { provide: Compiler, useFactory: createCompiler, deps: [CompilerFactory] },
                    {
                        provide: APP_INITIALIZER,
                        multi: true,
                        useFactory: (config) => {
                            return () => {
                                config.load();
                            };
                        },
                        deps: [ConfigurationService],
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LightformsCoreModule, { declarations: [HeaderComponent,
        FooterComponent, DetailPageComponent,
        JsonViewerComponent,
        ListPageComponent,
        ReportingComponent,
        TestListPageComponent,
        RoutesManagerComponent, DataEditorComponent, RequestAccessComponent], imports: [CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        ClipboardModule,
        NgxJsonViewerModule,
        LightformsComponentsModule,
        LightformsServicesModule], exports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HeaderComponent,
        FooterComponent, DetailPageComponent,
        JsonViewerComponent,
        ListPageComponent,
        ReportingComponent,
        TestListPageComponent,
        RoutesManagerComponent, DataEditorComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DataEditorComponent, DetailPageComponent, FooterComponent, HeaderComponent, JsonViewerComponent, LightformsCoreModule, ListPageComponent, ReportingComponent, RoutesManagerComponent, TestListPageComponent, createCompiler };
